import script from "./FormHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FormHeader.vue?vue&type=script&setup=true&lang=js"

import "./FormHeader.vue?vue&type=style&index=0&id=c868f08a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c868f08a"]])

export default __exports__